import { EsimPackageGroup } from "@/lib/redux/features/esim/types";

export const getEsimCardTitle = (group: EsimPackageGroup) => group.name;

export const getEsimVariantSummary = (data: string, validity: string) =>
  [data, validity].filter(Boolean).join(" · ");

export const getEsimCardCoverage = (countryName?: string) =>
  countryName?.trim() || "";
